<template>
  <div class="user__tree">
    <!-- 树型结构 -->
    <el-tree class="tree-line" ref="tree" :lazy="true" :data="treeData" :props="props" :load="loadNode"
             @node-click="nodeClick" :filter-node-method="filterNode"
    >
      <div class="comp-tr-node" slot-scope="{ node, data }" style="position: relative;">
        <template>
          <!-- 名称： 新增节点增加class（is-new） -->
          <span>{{ node.label }} </span>
          <!-- 按钮 -->
          <span style="position: absolute;top: -6px;left: 85px;">
            <!-- 新增 -->
            <el-button type="text" v-if="showAdd && node.level < maxLevel" size="mini" @click.stop="() => append(node)">
              <i slot="default" class="el-icon-circle-plus"></i>
            </el-button>
          </span>
        </template>
      </div>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "index",
  props: {
    maxLevel: {
      type: Number
    },
    requestData: {  // 3个参数，父id/resolve/leaf
      type: Function
    },
    showAdd: {

    }
  },
  data() {
    return {
      treeData: [],
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
        dataId: 'dataId',
        categoryType: 'categoryType'
      },
    }
  },
  methods: {
    // 节点加载
    loadNode(node, resolve) {
      console.log(node)
      if (node.level === 0) {  // 根节点，父id为空
        this.requestData('', resolve, false)
      } else {
        if (node.level < this.maxLevel - 1) {
          console.log('77777777777777777777')
          this.requestData(node.data.dataId, resolve, false)
        } else if (node.level === this.maxLevel - 1) {
          console.log('8888888888888888888888')
          this.requestData(node.data.dataId, resolve, true)
        }
      }
    },

    // 节点点击，向父组件传递id
    nodeClick(node) {
      this.$emit('nodeClick', node.dataId)
    },


    append(parentNode) {
      if (!parentNode.children) {
        this.$set(parentNode, 'children', []);
      }
      console.log(parentNode)
      new Promise((resolve, reject) => {
        // console.log(parentNode.data, 'tree --------------')
        let leaf = parentNode.level === this.maxLevel - 1
        this.$emit('addNodeHandle', resolve, leaf, parentNode.data.dataId, parentNode.data.categoryType)
      }).then(newChild => {
        console.log(newChild, 'newChild')
        console.log(parentNode)
        parentNode.isLeaf = false
        console.log(parentNode)
        this.$refs.tree.append(newChild, parentNode)
      })
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    filterRef(val) {
      this.$refs.tree.filter(val);
    }
  }
}
</script>

<style lang="scss" scoped>
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel{
  .el-radio__inner{
    border: 0px;
    background:transparent;
  }
  .el-radio__input.is-checked .el-radio__inner{
    background:none;
  }
  .el-radio{
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

  .table_main {
		padding-top: 5px;
    padding-left: 5px;
    border: 1px solid #ededed;
		width: calc(100% - 215px);
		border-bottom: none;
    .el-pagination {
    padding: 2px;

}
  }
.left_tree{
	width: 205px;
	.title{
	text-align: left;
	width: 182px;
	padding: 7px 0 5px !important;
			font-size: 13px;
			color: rgba(58, 39, 39, 0.96);
			>span{
				position: relative;
    left: 4px;
    top: -3px;
			}
}

::v-deep.el-tree-node__label {
	    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
}
}
.tree_icon{
	background: #f0f3ff;
}
// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }
  .el-tree-node__content {
    margin-top: 0px;
  }
  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }
  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;
    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}
.user__tree{
  font-size: 13px;
			color: rgba(58, 39, 39, 0.96);
}
</style>
